import { create } from "zustand";
import axios from "axios";

interface Event {
    id: number;
    name: string;
    description: string;
}

interface EventsStore {
    event: Event | null;
    fetchAndSetEvent: (eventId: number, onError: (err: any) => void) => Promise<Event>;
}

async function fetchEvent(eventId: number, onError: (err: any) => void): Promise<Event> {
    try {
        const res = await axios.get(`wp-json/tts-booking/v1/events`);
        // Filter event by id
        const event = res.data.find((event: Event) => event.id === eventId);
        return event;
    } catch (err) {
        onError(err);
        return Promise.reject();
    }
}

export const useEvent = create<EventsStore>((set, get) => ({
    event: null,
    fetchAndSetEvent: async (eventId: number, onError: (err: any) => void) => {
        try {
            const event = await fetchEvent(eventId, onError);
            set({ event: event });
            return Promise.resolve(event);
        } catch (err) {
            console.log(err);
        }
        return Promise.reject();
    }
}));